var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card-text',[_c('h2',[_vm._v("Регистрация")]),_c('br'),_c('b-form',[_c(_vm.isCurrentComponent,{tag:"component"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }